<div>
    <div [ngStyle]="{paddingTop: '0.1rem'}">
        <p-messages></p-messages>
    </div>

    @if (showLoading) {
        <div style="text-align: center" [ngStyle]="{minHeight: contentMinHeight}">
            <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration="1.5s"></p-progressSpinner>
            <div class="mt-2 mb-2">
                {{ loadingStr }}
            </div>
        </div>
    } @else {
        <div
            [style.flex-grow]="'1'"
            [style.overflow-y]="'auto'"
            [ngStyle]="{minHeight: contentMinHeight, paddingTop: '0.5rem'}"
            class="floatingLabelContainer"
        >
            <div class="border p-2">
                <div class="d-flex" [pTooltip]="expectedSchemaDescription">
                    <div class="w-50">Expected Type :</div>
                    <div class="w-50 fw-bold">{{ expectedTypeLabel | titlecase }}</div>
                </div>
                @if (expectedObjectSchemaKey) {
                    <div class="d-flex" [pTooltip]="expectedSchemaDescription">
                        <div class="w-50">Expected Schema :</div>
                        <div class="w-50 fw-bold">{{ expectedObjectSchemaKey }}</div>
                    </div>
                }
            </div>

            <p-message class="d-flex" severity="info" icon="pi pi-sparkles" size="small"
                >You can select an external reference as the value for this input. However, you can only
                select a reference that matches the expected type.
            </p-message>

            <div class="d-none">Result reference expression:</div>
            <p-inputgroup class="w-full d-none">
                <p-inputgroup-addon>&#36;&#123;</p-inputgroup-addon>
                <input type="text" pInputText placeholder="Attribute" disabled="true" [value]="attributeName?.data" />
                <p-inputgroup-addon>&#64;</p-inputgroup-addon>
                <input
                    type="text"
                    pInputText
                    placeholder="Source Type"
                    disabled="true"
                    [value]="sourceType"
                    [style.width]="'5rem !important'"
                />
                <p-inputgroup-addon>:</p-inputgroup-addon>
                <input
                    type="text"
                    pInputText
                    placeholder="Source Identifier"
                    disabled="true"
                    [value]="sourceIdentifier"
                />
                <p-inputgroup-addon>&#125;</p-inputgroup-addon>
            </p-inputgroup>

            <p-floatlabel variant="on" class="d-none">
                <p-select
                    id="sourceType"
                    [autoDisplayFirst]="false"
                    [options]="sourceTypeOptions"
                    [required]="true"
                    pTooltip="Data source type"
                    [(ngModel)]="sourceType"
                    appendTo="body"
                    [disabled]="config.data?.readOnly ?? true"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onSourceTypeChanged()"
                />
                <label for="sourceType" [attr.data-required]="true">Source Type</label>
            </p-floatlabel>

            <p-floatlabel variant="on" class="d-none">
                <p-select
                    id="sourceIdentifier"
                    [autoDisplayFirst]="false"
                    [options]="sourceIdentifierOptions"
                    [required]="true"
                    pTooltip="Data source identifier"
                    [(ngModel)]="sourceIdentifier"
                    appendTo="body"
                    [disabled]="!sourceType || (config.data?.readOnly ?? true)"
                    [ngModelOptions]="{standalone: true}"
                />
                <label for="sourceIdentifier" [attr.data-required]="true">Source Identifier</label>
            </p-floatlabel>

            <p-floatlabel variant="on">
                <p-treeSelect
                    id="attributeName"
                    containerStyleClass="width-form"
                    [options]="attributeNameOptions"
                    [showClear]="true"
                    pTooltip="Reference to get data from"
                    title="Select a reference to bind"
                    emptyMessage="No reference found"
                    [filter]="true"
                    [filterInputAutoFocus]="true"
                    selectionMode="single"
                    [(ngModel)]="attributeName"
                    appendTo="body"
                    panelStyleClass="reference-expression-attribute-panel"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="35"
                    [virtualScrollOptions]="{scrollHeight: '20rem'}"
                    [disabled]="!sourceType || (config.data?.readOnly ?? true)"
                    [ngModelOptions]="{standalone: true}"
                >
                    <ng-template pTemplate="default" let-node>
                        @if (node.data) {
                            <div class="reference-expression-attribute-option">
                                <span
                                    #attributeOptionKey
                                    class="reference-expression-attribute-option-key"
                                    [class.incompatible]="node.selectable === false"
                                    (mouseenter)="updateAttributeOptionTitle(attributeOptionKey, node.label)"
                                    >{{ node.label }}</span
                                >
                                <span class="reference-expression-attribute-option-tags">
                                    <p-chip
                                        value="Incompatible"
                                        class="reference-expression-attribute-option-tags-incompatible"
                                        [ngStyle]="{
                                            'text-decoration': node.selectable === false ? 'line-through' : 'none'
                                        }"
                                        >{{ node.typeLabel }}</p-chip
                                    >
                                    @if (node.levelLabel) {
                                        <p-chip
                                            class="reference-expression-attribute-option-tags-secondary"
                                            severity="secondary"
                                            >{{ node.levelLabel }}</p-chip
                                        >
                                    }
                                </span>
                            </div>
                        } @else {
                            <span>{{ node.label }}</span>
                        }
                    </ng-template>
                </p-treeSelect>
                <label for="attributeName" [attr.data-required]="true">Reference</label>
            </p-floatlabel>
            <p-button
                class="d-flex justify-content-end"
                severity="contrast"
                icon="pi pi-eye"
                type="button"
                label="View current value"
                (onClick)="onDisplayCurrentValue()"
                *ngIf="attributeName"
            />
        </div>
    }
    <div class="p-dialog-footer">
        <p-button severity="contrast" icon="pi pi-times" type="button" label="Cancel" (onClick)="onCancel()" />
        <p-button
            severity="primary"
            [icon]="attributeName ? 'pi pi-check' : 'pi pi-plus'"
            [label]="attributeName ? 'Continue' : 'Create default key'"
            (onClick)="onPrimaryAction()"
            [disabled]="showLoading || (!attributeName && !canCreateDefaultKey)"
        />
    </div>
</div>
